/* eslint-disable max-len */
import React, { Fragment } from 'react'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState, useRef } from 'react';
import TableTemplateBody from './TableTemplateBody';

const TableTemplate = ({ pageNumber, List, handleSearchParams, setConfirmationState, loading, handleDelete, isPatientTemplateTable, setChooseTemplate, templateTrigger, templateResult }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef();
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    return (
        <div>
            <div>
                <table aria-label="Outside Table" className={`w-full ${isPatientTemplateTable !== undefined ? 'table-fixed' : 'table-auto'}`}>
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-[0px] left-0 z-[9]">

                            <th id="permission" className={`px-[18px] py-2 ${isPatientTemplateTable === undefined ? 'w-[235px]' : 'w-[400px]'} rounded-tl-sm rounded-bl-sm`} >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Template Name

                                </span>
                            </th>
                            <th id="username" className="px-[18px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm" >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Created Date

                                </span>
                            </th>
                            {isPatientTemplateTable === undefined && <th className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] top-0 sticky right-[-1px] bg-[#EDD7E1] w-[90px] ">
                                <span className="flex items-center justify-center  text-sm font-normal text-[#000000]">Actions
                                </span>
                            </th>}

                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item, index) => (
                            <Fragment key={index}>
                                <TableTemplateBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    loading={loading}
                                    handleDelete={handleDelete}
                                    isPatientTemplateTable={isPatientTemplateTable}
                                    setChooseTemplate={setChooseTemplate}
                                    templateTrigger={templateTrigger}
                                    templateResult={templateResult}
                                />
                            </Fragment>
                        ))}


                    </tbody>

                </table>

            </div>
        </div>
    )
}

export default TableTemplate